const CreativeAgencyOneSupport = () => {
  return (
    <>
      <div className="ca-support">
        <div className="container-lg">
          <div className="row">
            <div className="col-12">
              <div className="ca-support__content bgc-white drop-shadow">
                <div className="row g-4 gx-xl-5 align-items-center">
                  <div className="col-md-3">
                    <img
                      src="assets/img/creative-agency/support-img.png"
                      alt="image"
                      className="img-fluid"
                    />
                  </div>
                  <div className="col-md-9">
                    <div className="d-flex align-items-center justify-content-between gap-4 flex-wrap flex-md-nowrap">
                      <h5 className="heading-5 mb-0 flex-grow-1 font-weight-bold clr-text max-24ch">
                        24/7 Chat Support for Quiety Desk Users
                      </h5>
                      <a
                        href="#"
                        className="link d-inline-flex padding-y-4 padding-x-10 text-center font-weight-semibold clr-white :clr-white bgc-danger rounded-pill flex-shrink-0"
                      >
                        Contact Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreativeAgencyOneSupport;
